<template>
  <div>
    <v-row v-for="(filter, i) of value" :key="i">
      <v-col class="flex-grow-1 flex-shrink-1">
        <v-select
          dense
          label="Field"
          :items="fields"
          :value="filter.field"
          @input="onChangeFilterField(i, $event)"
        />
      </v-col>
      <v-col class="flex-grow-1 flex-shrink-0">
        <v-select
          dense
          label="Operator"
          :items="filter.field ? fieldOperators[filter.field] : []"
          :value="filter.operator"
          @input="onChangeFilterOperator(i, $event)"
        />
      </v-col>
      <v-col class="flex-grow-1 flex-shrink-0">
        <v-checkbox
          v-if="filter.operator === 'exists'"
          dense
          label="Value"
          :value="filter.value"
          @change="onChangeFilterValue(i, $event)"
        />
        <date-input
          v-else-if="filter.field && fieldMap[filter.field].type === Date"
          dense
          label="Value"
          :value="filter.value"
          @input="onChangeFilterValue(i, $event)"
        />
        <v-text-field
          v-else
          dense
          label="Value"
          :value="filter.value"
          @input="onChangeFilterValue(i, $event)"
        />
      </v-col>
      <v-col class="flex-grow-0 flex-shrink-1">
        <v-btn
          fab
          outlined
          x-small
          color="error"
          @click="onRemoveFilter(i)"
        >
          <v-icon>remove</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="flex-grow-1 flex-shrink-1">
        <v-select
          dense
          label="Field"
          :items="fields"
          v-model="form.field"
        />
      </v-col>
      <v-col>
        <v-select
          dense
          label="Operator"
          :items="form.field ? fieldOperators[form.field] : []"
          :value="form.operator"
          @input="onChangeFormOperator($event)"
        />
      </v-col>
      <v-col class="flex-grow-1 flex-shrink-0">
        <v-checkbox
          v-if="form.operator === 'exists'"
          dense
          label="Value"
          v-model="form.value"
        />
        <date-input
          v-else-if="form.field && fieldMap[form.field].type === Date"
          dense
          label="Value"
          v-model="form.value"
        />
        <v-text-field
          v-else
          dense
          label="Value"
          v-model="form.value"
        />
      </v-col>
      <v-col class="flex-grow-0 flex-shrink-1">
        <v-btn
          fab
          outlined
          x-small
          color="primary"
          @click="onAddFilter"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

import DateInput from '../inputs/DateInput.vue'

const operators = () => [
  { text: 'Equals', value: 'eq', defaultEnabled: true },
  { text: 'Not Equals', value: 'ne', defaultEnabled: true },
  { text: 'Exists', value: 'exists', default: false, defaultEnabled: true },
  { text: 'Like (Fuzzy)', value: 'like', defaultEnabled: false },
  { text: 'Greater Than', value: 'gt', defaultEnabled: false },
  { text: 'Greater Than or Equal To', value: 'gte', defaultEnabled: false },
  { text: 'Less Than', value: 'lt', defaultEnabled: false },
  { text: 'Less Than or Equal To', value: 'lte', defaultEnabled: false }
]

export default {
  name: 'FilterBuilderForm',

  components: {
    DateInput
  },

  props: {
    value: {
      type: Array
    },

    fields: {
      type: Array, // [{ value: 'name', text: 'Name', type: String, multiple: true, eq: true, ne: true, gt: true, lt: true, gte: true, lte: true, exists: true }]
      required: true
    }
  },

  data () {
    return {
      form: {
        field: this.fields[0].value,
        operator: 'eq',
        value: null
      }
    }
  },

  computed: {
    fieldMap () {
      return Object.fromEntries(this.fields.map(field => [field.value, field]))
    },

    // Create a map of field operators to use in the operator selection, depending on the field selected for the filter.
    fieldOperators () {
      const fieldOperators = {}
      const { fields, value } = this

      for (const field of fields) {
        fieldOperators[field.value] = operators()
          .filter(operator => {
            const enabled = field[operator.value]
            if (enabled === undefined) return operator.defaultEnabled
            return enabled
          })
          .map(operator => ({
            ...operator,
            disabled: value.some(filter => field.multiple === false && filter.field === field.value && filter.operator === operator.value)
          }))
      }

      return fieldOperators
    }
  },

  methods: {
    onAddFilter () {
      const newFilter = cloneDeep(this.form)
      this.resetForm()
      this.$emit('input', [...this.value, newFilter])
    },

    onRemoveFilter (i) {
      const filters = cloneDeep(this.value)
      filters.splice(i, 1)
      this.$emit('input', filters)
    },

    onChangeFormOperator (event) {
      const operator = operators().find(o => o.value === event)
      this.form.operator = event
      this.form.value = operator.default ?? null
      debugger
    },

    onChangeFilterValue (i, event) {
      const filters = cloneDeep(this.value)
      const filter = filters[i]
      const field = this.fields.find(f => f.value === filter.field)
      const useRawValue = filter.operator === 'exists' ||
        filter.operator === 'like' ||
        field.type === Date

      filter.value = useRawValue
        ? event
        : (field.type || String)(event)

      this.$emit('input', filters)
    },

    onChangeFilterField (i, event) {
      const filters = cloneDeep(this.value)
      const filter = filters[i]
      filter.field = event
      filter.value = null
      this.$emit('input', filters)
    },

    onChangeFilterOperator (i, event) {
      const operator = operators().find(o => o.value === event)
      const filters = cloneDeep(this.value)
      const filter = filters[i]
      filter.operator = event
      filter.value = operator.default ?? null
      this.$emit('input', filters)
    },

    resetForm () {
      this.form.field = this.fields[0].value
      this.form.operator = 'eq'
      this.form.value = null
    }
  }
}
</script>
